<template>
    <div class="server-monitoring-dashboard">
        <!-- Header do Dashboard -->
        <div class="dashboard-header mb-4">
            <h1 class="dashboard-title">
                <i class="fas fa-server me-3"></i>
                Monitoramento de Servidores
            </h1>
            <p class="dashboard-subtitle">Painel de controle e métricas em tempo real</p>
        </div>

        <!-- Cards de Resumo - Servidores -->
        <div class="metrics-section mb-5">
            <h2 class="section-title">
                <i class="fas fa-chart-pie me-2"></i>
                Visão Geral dos Servidores
            </h2>
            <div class="row g-4">
                <div class="col-xl-3 col-lg-12 col-md-12">
                    <div class="metric-card primary-gradient">
                        <div class="metric-content">
                            <div class="metric-info">
                                <h3 class="metric-value">{{ summary.total_servers }}</h3>
                                <p class="metric-label">Total de Servidores</p>
                                <div class="metric-description">Todos os servidores monitorados</div>
                            </div>
                            <div class="metric-icon">
                                <i class="fas fa-server"></i>
                            </div>
                        </div>
                        <div class="metric-footer">
                            <i class="fas fa-chart-line me-1"></i>
                            Sistema ativo
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6">
                    <div class="metric-card success-gradient">
                        <div class="metric-content">
                            <div class="metric-info">
                                <h3 class="metric-value">{{ summary.online_servers }}</h3>
                                <p class="metric-label">Servidores Online</p>
                                <div class="metric-description">Funcionando corretamente</div>
                            </div>
                            <div class="metric-icon">
                                <i class="fas fa-check-circle"></i>
                            </div>
                        </div>
                        <div class="metric-footer">
                            <i class="fas fa-heartbeat me-1"></i>
                            Operacional
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6">
                    <div class="metric-card danger-gradient">
                        <div class="metric-content">
                            <div class="metric-info">
                                <h3 class="metric-value">{{ summary.offline_servers }}</h3>
                                <p class="metric-label">Servidores Offline</p>
                                <div class="metric-description">Requerem atenção</div>
                            </div>
                            <div class="metric-icon">
                                <i class="fas fa-exclamation-circle"></i>
                            </div>
                        </div>
                        <div class="metric-footer">
                            <i class="fas fa-tools me-1"></i>
                            Manutenção
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6">
                    <div class="metric-card warning-gradient">
                        <div class="metric-content">
                            <div class="metric-info">
                                <h3 class="metric-value">{{ summary.critical_alerts }}</h3>
                                <p class="metric-label">Alertas Críticos</p>
                                <div class="metric-description">Ações imediatas necessárias</div>
                            </div>
                            <div class="metric-icon">
                                <i class="fas fa-exclamation-triangle"></i>
                            </div>
                        </div>
                        <div class="metric-footer">
                            <i class="fas fa-bell me-1"></i>
                            Urgente
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Cards de Aplicações -->
        <div class="metrics-section mb-5">
            <h2 class="section-title">
                <i class="fas fa-code me-2"></i>
                Aplicações por Tecnologia
            </h2>
            <div class="row g-4">
                <div class="col-xl-3 col-lg-6 col-md-6">
                    <div class="metric-card info-gradient">
                        <div class="metric-content">
                            <div class="metric-info">
                                <h3 class="metric-value">{{ summary.total_applications || 0 }}</h3>
                                <p class="metric-label">Total Aplicações</p>
                                <div class="metric-description">Todas as aplicações detectadas</div>
                            </div>
                            <div class="metric-icon">
                                <i class="fas fa-layer-group"></i>
                            </div>
                        </div>
                        <div class="metric-footer">
                            <i class="fas fa-database me-1"></i>
                            Monitoradas
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6">
                    <div class="metric-card dark-gradient">
                        <div class="metric-content">
                            <div class="metric-info">
                                <h3 class="metric-value">{{ summary.backend_applications || 0 }}</h3>
                                <p class="metric-label">Backend Laravel</p>
                                <div class="metric-description">APIs e serviços backend</div>
                            </div>
                            <div class="metric-icon">
                                <i class="fab fa-laravel"></i>
                            </div>
                        </div>
                        <div class="metric-footer">
                            <i class="fas fa-cogs me-1"></i>
                            PHP Framework
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6">
                    <div class="metric-card vue-gradient">
                        <div class="metric-content">
                            <div class="metric-info">
                                <h3 class="metric-value">{{ summary.frontend_applications || 0 }}</h3>
                                <p class="metric-label">Frontend Vue.js</p>
                                <div class="metric-description">Interfaces de usuário</div>
                            </div>
                            <div class="metric-icon">
                                <i class="fab fa-vuejs"></i>
                            </div>
                        </div>
                        <div class="metric-footer">
                            <i class="fas fa-palette me-1"></i>
                            JavaScript Framework
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6">
                    <div class="metric-card neutral-gradient">
                        <div class="metric-content">
                            <div class="metric-info">
                                <h3 class="metric-value">{{ summary.other_applications || 0 }}</h3>
                                <p class="metric-label">Outras Tecnologias</p>
                                <div class="metric-description">Diversas tecnologias</div>
                            </div>
                            <div class="metric-icon">
                                <i class="fas fa-cubes"></i>
                            </div>
                        </div>
                        <div class="metric-footer">
                            <i class="fas fa-tools me-1"></i>
                            Variadas
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Lista de Servidores e Alertas -->
        <div class="row g-4">
            <div class="col-lg-12">
                <div class="data-card">
                    <div class="card-header-custom">
                        <div class="header-content">
                            <h3 class="card-title-custom">
                                <i class="fas fa-list me-2"></i>
                                Servidores Monitorados
                            </h3>
                            <div class="header-actions">
                                <button class="btn-refresh" @click="refreshData" :disabled="loading">
                                    <i class="fas fa-sync-alt" :class="{ 'fa-spin': loading }"></i>
                                    <span>Atualizar</span>
                                </button>
                                <button class="btn-clear-data" @click="showClearConfirmation" :disabled="loading">
                                    <i class="fas fa-trash-alt"></i>
                                    <span>Limpar Dados</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body-custom">
                        <div class="table-responsive">
                            <table class="modern-table">
                                <thead>
                                    <tr>
                                        <th><i class="fas fa-server me-1"></i>Servidor</th>
                                        <th><i class="fas fa-network-wired me-1"></i>Rede</th>
                                        <th><i class="fas fa-heartbeat me-1"></i>Status</th>
                                        <th><i class="fas fa-microchip me-1"></i>CPU</th>
                                        <th><i class="fas fa-memory me-1"></i>RAM</th>
                                        <th><i class="fas fa-hdd me-1"></i>Disco</th>
                                        <th><i class="fas fa-bell me-1"></i>Alertas</th>
                                        <th><i class="fas fa-cog me-1"></i>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="server in servers" :key="server.id" class="server-row">
                                        <td class="server-info">
                                            <div class="server-name">{{ server.hostname }}</div>
                                            <div class="server-description">{{ server.description }}</div>
                                        </td>
                                        <td class="network-info">
                                            <div class="ip-address">
                                                <i class="fas fa-globe me-1"></i>
                                                {{ server.ip_address }}
                                            </div>
                                        </td>
                                        <td>
                                            <span class="status-badge"
                                                :class="server.is_online ? 'status-online' : 'status-offline'">
                                                <i :class="server.is_online ? 'fas fa-circle' : 'fas fa-times-circle'"
                                                    class="me-1"></i>
                                                {{ server.is_online ? 'Online' : 'Offline' }}
                                            </span>
                                        </td>
                                        <td>
                                            <div v-if="server.latest_metrics" class="metric-container">
                                                <div class="modern-progress">
                                                    <div class="progress-fill"
                                                        :class="getProgressClass(server.latest_metrics.cpu_usage_percent, 85)"
                                                        :style="{ width: server.latest_metrics.cpu_usage_percent + '%' }">
                                                    </div>
                                                    <span class="progress-text">{{
                                                        server.latest_metrics.cpu_usage_percent }}%</span>
                                                </div>
                                            </div>
                                            <span v-else class="no-data">N/A</span>
                                        </td>
                                        <td>
                                            <div v-if="server.latest_metrics" class="metric-container">
                                                <div class="modern-progress">
                                                    <div class="progress-fill"
                                                        :class="getProgressClass(server.latest_metrics.ram_used_percent, 90)"
                                                        :style="{ width: server.latest_metrics.ram_used_percent + '%' }">
                                                    </div>
                                                    <span class="progress-text">{{
                                                        server.latest_metrics.ram_used_percent }}%</span>
                                                </div>
                                            </div>
                                            <span v-else class="no-data">N/A</span>
                                        </td>
                                        <td>
                                            <div v-if="server.latest_metrics" class="metric-container">
                                                <div class="modern-progress">
                                                    <div class="progress-fill"
                                                        :class="getProgressClass(server.latest_metrics.disk_used_percent, 80)"
                                                        :style="{ width: server.latest_metrics.disk_used_percent + '%' }">
                                                    </div>
                                                    <span class="progress-text">{{
                                                        server.latest_metrics.disk_used_percent }}%</span>
                                                </div>
                                            </div>
                                            <span v-else class="no-data">N/A</span>
                                        </td>
                                        <td>
                                            <span v-if="server.alerts_count > 0" class="alert-badge alert-warning">
                                                <i class="fas fa-exclamation-triangle me-1"></i>
                                                {{ server.alerts_count }}
                                            </span>
                                            <span v-else class="alert-badge alert-success">
                                                <i class="fas fa-check me-1"></i>
                                                0
                                            </span>
                                        </td>
                                        <td>
                                            <div class="action-buttons">
                                                <router-link :to="`/servers/${server.id}`" class="action-btn view-btn"
                                                    title="Ver detalhes do servidor">
                                                    <i class="fas fa-eye"></i>
                                                    <span>Detalhes</span>
                                                </router-link>
                                                <button class="action-btn delete-btn" 
                                                    @click="deleteServer(server.id, server.hostname)"
                                                    title="Deletar servidor">
                                                    <i class="fas fa-trash"></i>
                                                    <span>Deletar</span>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Painel de Alertas -->
            <div class="col-lg-6 mt-4">
                <div class="data-card alerts-card">                    
                    <div class="card-body-custom">
                        <alerts-panel :alerts="alerts" @refresh="loadAlerts"></alerts-panel>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 mt-4">
                <div class="data-card activity-card">
                    <div class="card-header-custom">
                        <h3 class="card-title-custom">
                            <i class="fas fa-clock me-2"></i>
                            Atividade Recente
                        </h3>
                    </div>
                    <div class="card-body-custom">
                        <div class="activity-list">
                            <div v-for="server in recentServers" :key="server.id" class="activity-item">
                                <div class="activity-info">
                                    <div class="activity-server">{{ server.hostname }}</div>
                                    <div class="activity-time">
                                        <i class="fas fa-clock me-1"></i>
                                        {{ formatDate(server.latest_metrics?.collected_at) }}
                                    </div>
                                </div>
                                <div class="activity-status">
                                    <span class="status-badge"
                                        :class="server.is_online ? 'status-online' : 'status-offline'">
                                        <i :class="server.is_online ? 'fas fa-circle' : 'fas fa-times-circle'"
                                            class="me-1"></i>
                                        {{ server.is_online ? 'Online' : 'Offline' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Pesquisa de Aplicações -->
        <div class="row g-4 mt-4">
            <div class="col-lg-12">
                <div class="data-card">
                    <div class="card-header-custom">
                        <div class="header-content">
                            <h3 class="card-title-custom">
                                <i class="fas fa-search me-2"></i>
                                Pesquisa de Aplicações
                            </h3>
                            <div class="header-actions">
                                <button class="btn-refresh" @click="searchApplications" :disabled="searching">
                                    <i class="fas fa-search" :class="{ 'fa-spin': searching }"></i>
                                    <span>Pesquisar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body-custom">
                        <!-- Filtros de Pesquisa -->
                        <div class="search-filters mb-4">
                            <div class="row g-3">
                                <div class="col-md-4">
                                    <input v-model="searchFilters.search" 
                                           type="text" 
                                           class="form-control" 
                                           placeholder="Buscar por nome, caminho, tipo ou servidor..."
                                           @keyup.enter="searchApplications">
                                </div>
                                <div class="col-md-2">
                                    <select v-model="searchFilters.type" class="form-control">
                                        <option value="">Todos os tipos</option>
                                        <option value="laravel">Laravel</option>
                                        <option value="vuejs">Vue.js</option>
                                        <option value="react">React</option>
                                        <option value="angular">Angular</option>
                                        <option value="nodejs">Node.js</option>
                                        <option value="python">Python</option>
                                        <option value="java">Java</option>
                                        <option value="php">PHP</option>
                                    </select>
                                </div>
                                <div class="col-md-2">
                                    <select v-model="searchFilters.env_production" class="form-control">
                                        <option value="">Todos os ambientes</option>
                                        <option value="1">Produção</option>
                                        <option value="0">Desenvolvimento</option>
                                    </select>
                                </div>
                                <div class="col-md-2">
                                    <select v-model="searchFilters.debug_enabled" class="form-control">
                                        <option value="">Debug</option>
                                        <option value="1">Ativo</option>
                                        <option value="0">Inativo</option>
                                    </select>
                                </div>
                                <div class="col-md-2">
                                    <button class="btn btn-primary w-100" @click="searchApplications">
                                        <i class="fas fa-search me-1"></i>
                                        Buscar
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Resultados da Pesquisa -->
                        <div v-if="searchResults.length > 0" class="search-results">
                            <div class="table-responsive">
                                <table class="modern-table">
                                    <thead>
                                        <tr>
                                            <th>Aplicação</th>
                                            <th>Tipo</th>
                                            <th>Servidor</th>
                                            <th>Caminho</th>
                                            <th>Ambiente</th>
                                            <th>Debug</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="app in searchResults" :key="app.id" class="application-row">
                                            <td>
                                                <div class="app-info">
                                                    <div class="app-name">{{ app.name }}</div>
                                                    <div class="app-size" v-if="app.size_mb">
                                                        {{ app.size_mb }}MB
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <span class="type-badge" :class="getTypeClass(app.type)">
                                                    {{ app.type }}
                                                </span>
                                            </td>
                                            <td>
                                                <div class="server-info">
                                                    <div class="server-name">{{ app.server.hostname }}</div>
                                                    <div class="server-ip">{{ app.server.ip_address }}</div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="path-info">
                                                    <code>{{ app.path }}</code>
                                                </div>
                                            </td>
                                            <td>
                                                <span class="env-badge" :class="app.env_production ? 'env-production' : 'env-development'">
                                                    {{ app.env_production ? 'Produção' : 'Desenvolvimento' }}
                                                </span>
                                            </td>
                                            <td>
                                                <span class="debug-badge" :class="app.debug_enabled ? 'debug-enabled' : 'debug-disabled'">
                                                    {{ app.debug_enabled ? 'Ativo' : 'Inativo' }}
                                                </span>
                                            </td>
                                            <td>
                                                <span class="status-badge" :class="app.has_alerts ? 'status-warning' : 'status-success'">
                                                    <i :class="app.has_alerts ? 'fas fa-exclamation-triangle' : 'fas fa-check'"></i>
                                                    {{ app.has_alerts ? 'Alertas' : 'OK' }}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                            <!-- Paginação -->
                            <div v-if="pagination.total > pagination.per_page" class="pagination-container mt-4">
                                <nav>
                                    <ul class="pagination justify-content-center">
                                        <li class="page-item" :class="{ disabled: pagination.current_page === 1 }">
                                            <button class="page-link" @click="changePage(pagination.current_page - 1)">
                                                <i class="fas fa-chevron-left"></i>
                                            </button>
                                        </li>
                                        <li v-for="page in getPageNumbers()" :key="page" 
                                            class="page-item" :class="{ active: page === pagination.current_page }">
                                            <button class="page-link" @click="changePage(page)">{{ page }}</button>
                                        </li>
                                        <li class="page-item" :class="{ disabled: pagination.current_page === pagination.last_page }">
                                            <button class="page-link" @click="changePage(pagination.current_page + 1)">
                                                <i class="fas fa-chevron-right"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                                <div class="pagination-info text-center mt-2">
                                    Mostrando {{ pagination.from }} a {{ pagination.to }} de {{ pagination.total }} aplicações
                                </div>
                            </div>
                        </div>

                        <!-- Mensagem quando não há resultados -->
                        <div v-else-if="searched" class="no-results">
                            <div class="text-center py-5">
                                <i class="fas fa-search fa-3x text-muted mb-3"></i>
                                <h4 class="text-muted">Nenhuma aplicação encontrada</h4>
                                <p class="text-muted">Tente ajustar os filtros de pesquisa</p>
                            </div>
                        </div>

                        <!-- Estado inicial -->
                        <div v-else class="initial-state">
                            <div class="text-center py-5">
                                <i class="fas fa-search fa-3x text-muted mb-3"></i>
                                <h4 class="text-muted">Pesquise aplicações</h4>
                                <p class="text-muted">Use os filtros acima para encontrar aplicações específicas</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Gráficos e Estatísticas -->
        <div class="row g-4 mt-4">
            <div class="col-lg-12">
                <div class="data-card chart-card">
                    <div class="card-header-custom">
                        <h3 class="card-title-custom">
                            <i class="fas fa-chart-pie me-2"></i>
                            Distribuição de Aplicações
                        </h3>
                    </div>
                    <div class="card-body-custom">
                        <applications-chart :applications-by-type="applicationsByType" />
                    </div>
                </div>
            </div>

        </div>

        <!-- Modal de Confirmação para Limpeza -->
        <div v-if="showClearModal" class="modal-overlay" @click="hideClearConfirmation">
            <div class="confirmation-modal" @click.stop>
                <div class="modal-header">
                    <h3 class="modal-title">
                        <i class="fas fa-exclamation-triangle text-danger me-2"></i>
                        Confirmar Limpeza de Dados
                    </h3>
                </div>
                <div class="modal-body">
                    <p class="warning-text">
                        <strong>ATENÇÃO:</strong> Esta ação irá deletar permanentemente:
                    </p>
                    <ul class="deletion-list">
                        <li><i class="fas fa-server me-2"></i>Todos os servidores cadastrados</li>
                        <li><i class="fas fa-chart-line me-2"></i>Todo o histórico de métricas</li>
                        <li><i class="fas fa-code me-2"></i>Todas as aplicações detectadas</li>
                        <li><i class="fas fa-bell me-2"></i>Todos os alertas gerados</li>
                    </ul>
                    <p class="warning-text">
                        <strong>Esta ação não pode ser desfeita!</strong>
                    </p>
                    <div class="confirmation-input">
                        <label for="confirmText">Digite <strong>"LIMPAR"</strong> para confirmar:</label>
                        <input id="confirmText" v-model="confirmationText" type="text" class="form-control"
                            placeholder="Digite LIMPAR" @keyup.enter="clearAllData">
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn-cancel" @click="hideClearConfirmation">
                        <i class="fas fa-times me-1"></i>
                        Cancelar
                    </button>
                    <button class="btn-confirm-delete" @click="clearAllData"
                        :disabled="confirmationText !== 'LIMPAR' || clearing">
                        <i class="fas fa-trash-alt me-1" :class="{ 'fa-spin': clearing }"></i>
                        {{ clearing ? 'Limpando...' : 'Confirmar Limpeza' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AlertsPanel from './AlertsPanel.vue'
import ApplicationsChart from './ApplicationsChart.vue'

export default {
    name: 'ServerDashboard',
    components: {
        AlertsPanel,
        ApplicationsChart
    },
    data() {
        return {
            loading: false,
            clearing: false,
            showClearModal: false,
            confirmationText: '',
            summary: {
                total_servers: 0,
                online_servers: 0,
                offline_servers: 0,
                critical_alerts: 0
            },
            servers: [],
            alerts: [],
            recentServers: [],
            applicationsByType: {},
            refreshInterval: null,
            // Novas propriedades para pesquisa de aplicações
            searching: false,
            searched: false,
            searchResults: [],
            pagination: {
                current_page: 1,
                last_page: 1,
                per_page: 50,
                total: 0,
                from: 0,
                to: 0
            },
            searchFilters: {
                search: '',
                type: '',
                env_production: '',
                debug_enabled: ''
            }
        }
    },
    mounted() {
        this.loadDashboard()
        this.loadServers()
        this.loadAlerts()

        // Auto-refresh a cada 30 segundos
        this.refreshInterval = setInterval(() => {
            this.refreshData()
        }, 30000)
    },
    beforeDestroy() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval)
        }
    },
    methods: {
        async loadDashboard() {
            try {
                const response = await this.$http.get(this.$store.getters.api + 'server-monitoring/dashboard')
                const data = response.data

                this.summary = data.summary
                this.recentServers = data.recent_servers
                this.applicationsByType = data.applications_by_type
            } catch (error) {
                console.error('Erro ao carregar dashboard:', error)
                this.$toast.error('Erro ao carregar dados do dashboard')
            }
        },

        async loadServers() {
            try {
                const response = await this.$http.get(this.$store.getters.api + 'server-monitoring/servers')
                this.servers = response.data.data
            } catch (error) {
                console.error('Erro ao carregar servidores:', error)
                this.$toast.error('Erro ao carregar lista de servidores')
            }
        },

        async loadAlerts() {
            try {
                const response = await this.$http.get(this.$store.getters.api + 'server-monitoring/alerts')
                this.alerts = response.data.data
            } catch (error) {
                console.error('Erro ao carregar alertas:', error)
                this.$toast.error('Erro ao carregar alertas')
            }
        },

        async refreshData() {
            this.loading = true
            try {
                await Promise.all([
                    this.loadDashboard(),
                    this.loadServers(),
                    this.loadAlerts()
                ])
            } finally {
                this.loading = false
            }
        },

        getProgressClass(value, threshold) {
            if (value >= threshold) {
                return 'bg-danger'
            } else if (value >= threshold * 0.8) {
                return 'bg-warning'
            } else {
                return 'bg-success'
            }
        },

        formatDate(date) {
            if (!date) return 'N/A'
            return new Date(date).toLocaleString('pt-BR')
        },

        showClearConfirmation() {
            this.showClearModal = true
            this.confirmationText = ''
        },

        hideClearConfirmation() {
            this.showClearModal = false
            this.confirmationText = ''
        },

        async clearAllData() {
            if (this.confirmationText !== 'LIMPAR') {
                this.$toast.warning('Digite "LIMPAR" para confirmar a ação')
                return
            }

            this.clearing = true

            try {
                await this.$http.delete(this.$store.getters.api + 'server-monitoring/clear-all-data')

                // Limpa os dados locais
                this.summary = {
                    total_servers: 0,
                    online_servers: 0,
                    offline_servers: 0,
                    critical_alerts: 0,
                    total_applications: 0,
                    backend_applications: 0,
                    frontend_applications: 0,
                    other_applications: 0
                }
                this.servers = []
                this.alerts = []
                this.recentServers = []
                this.applicationsByType = {}

                this.$toast.success('Todos os dados foram limpos com sucesso!')
                this.hideClearConfirmation()

            } catch (error) {
                console.error('Erro ao limpar dados:', error)
                if (error.response?.status === 404) {
                    this.$toast.error('Endpoint de limpeza não encontrado. Verifique a API.')
                } else {
                    this.$toast.error('Erro ao limpar dados: ' + (error.response?.data?.message || error.message))
                }
            } finally {
                this.clearing = false
            }
        },

        // Métodos para deletar servidor
        async deleteServer(serverId, hostname) {
            if (!confirm(`Tem certeza que deseja deletar o servidor "${hostname}"? Esta ação não pode ser desfeita.`)) {
                return
            }

            try {
                const response = await this.$http.delete(this.$store.getters.api + `server-monitoring/servers/${serverId}`)
                
                // Remove o servidor da lista local
                this.servers = this.servers.filter(server => server.id !== serverId)
                
                // Recarrega o dashboard para atualizar as estatísticas
                await this.loadDashboard()
                
                this.$toast.success(`Servidor "${hostname}" deletado com sucesso!`)
            } catch (error) {
                console.error('Erro ao deletar servidor:', error)
                let errorMessage = 'Erro ao deletar servidor'
                
                if (error.response) {
                    if (error.response.data && error.response.data.message) {
                        errorMessage += ': ' + error.response.data.message
                    } else if (error.response.status === 404) {
                        errorMessage += ': Servidor não encontrado'
                    } else if (error.response.status === 403) {
                        errorMessage += ': Sem permissão para deletar'
                    } else {
                        errorMessage += ': ' + error.response.statusText
                    }
                } else if (error.message) {
                    errorMessage += ': ' + error.message
                }
                
                this.$toast.error(errorMessage)
            }
        },

        // Métodos para pesquisa de aplicações
        async searchApplications() {
            this.searching = true
            this.searched = true

            try {
                const params = {
                    page: this.pagination.current_page,
                    per_page: this.pagination.per_page,
                    ...this.searchFilters
                }

                // Remove parâmetros vazios
                Object.keys(params).forEach(key => {
                    if (params[key] === '' || params[key] === null || params[key] === undefined) {
                        delete params[key]
                    }
                })

                const response = await this.$http.get(this.$store.getters.api + 'server-monitoring/search-applications', { params })
                const data = response.data

                this.searchResults = data.data
                this.pagination = data.pagination
            } catch (error) {
                console.error('Erro ao pesquisar aplicações:', error)
                this.$toast.error('Erro ao pesquisar aplicações: ' + (error.response?.data?.message || error.message))
                this.searchResults = []
            } finally {
                this.searching = false
            }
        },

        async changePage(page) {
            if (page < 1 || page > this.pagination.last_page) {
                return
            }
            this.pagination.current_page = page
            await this.searchApplications()
        },

        getPageNumbers() {
            const pages = []
            const current = this.pagination.current_page
            const last = this.pagination.last_page
            const delta = 2

            for (let i = Math.max(1, current - delta); i <= Math.min(last, current + delta); i++) {
                pages.push(i)
            }

            return pages
        },

        getTypeClass(type) {
            const typeClasses = {
                'laravel': 'type-laravel',
                'vuejs': 'type-vue',
                'vue': 'type-vue',
                'react': 'type-react',
                'angular': 'type-angular',
                'nodejs': 'type-node',
                'node': 'type-node',
                'python': 'type-python',
                'java': 'type-java',
                'php': 'type-php'
            }
            return typeClasses[type] || 'type-default'
        }
    }
}
</script>

<style scoped>
/* Layout Principal */
.server-monitoring-dashboard {
    padding: 30px;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    min-height: 100vh;
}

/* Header do Dashboard */
.dashboard-header {
    text-align: center;
    margin-bottom: 40px;
}

.dashboard-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: #2c3e50;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 10px;
}

.dashboard-subtitle {
    font-size: 1.1rem;
    color: #7f8c8d;
    margin: 0;
}

/* Seções de Métricas */
.metrics-section {
    margin-bottom: 40px;
}

.section-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 25px;
    padding-left: 15px;
    border-left: 4px solid #3498db;
}

/* Cards de Métricas */
.metric-card {
    background: white;
    border-radius: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: all 0.3s ease;
    border: none;
    height: 180px;
    position: relative;
}

.metric-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.metric-content {
    padding: 25px;
    height: 130px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
}

.metric-info h3 {
    font-size: 2.5rem;
    font-weight: 700;
    margin: 0 0 5px 0;
}

.metric-label {
    font-size: 1rem;
    font-weight: 600;
    margin: 0 0 8px 0;
    opacity: 0.9;
}

.metric-description {
    font-size: 0.85rem;
    opacity: 0.8;
    line-height: 1.3;
}

.metric-icon {
    font-size: 3rem;
    opacity: 0.3;
}

.metric-footer {
    background: rgba(255, 255, 255, 0.1);
    padding: 12px 25px;
    font-size: 0.85rem;
    font-weight: 500;
    backdrop-filter: blur(10px);
}

/* Gradientes dos Cards */
.primary-gradient {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.success-gradient {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.danger-gradient {
    background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
}

.warning-gradient {
    background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
    color: #333 !important;
}

.warning-gradient .metric-footer {
    background: rgba(0, 0, 0, 0.1);
}

.info-gradient {
    background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
    color: #333 !important;
}

.info-gradient .metric-footer {
    background: rgba(0, 0, 0, 0.1);
}

.dark-gradient {
    background: linear-gradient(135deg, #a4a4a4 0%, #5e5d5d 100%);
}

.vue-gradient {
    background: linear-gradient(135deg, #41b883 0%, #35495e 100%);
}

.neutral-gradient {
    background: linear-gradient(135deg, #bdc3c7 0%, #2c3e50 100%);
}

/* Cards de Dados */
.data-card {
    background: white;
    border-radius: 15px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    border: none;
    overflow: hidden;
    transition: all 0.3s ease;
}

.data-card:hover {
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
}

.card-header-custom {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-bottom: 1px solid #dee2e6;
    padding: 20px 25px;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-actions {
    display: flex;
    gap: 12px;
    align-items: center;
}

.card-title-custom {
    font-size: 1.25rem;
    font-weight: 600;
    color: #2c3e50;
    margin: 0;
}

.btn-refresh {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 8px;
    color: white;
    padding: 8px 16px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-refresh:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

.btn-refresh:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.btn-clear-data {
    background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
    border: none;
    border-radius: 8px;
    color: white;
    padding: 8px 16px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-clear-data:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(220, 53, 69, 0.3);
}

.btn-clear-data:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.card-body-custom {
    padding: 25px;
}

/* Tabela Moderna */
.modern-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 0.9rem;
}

.modern-table thead th {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    color: #495057;
    font-weight: 600;
    padding: 15px 12px;
    border: none;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.modern-table thead th:first-child {
    border-radius: 8px 0 0 0;
}

.modern-table thead th:last-child {
    border-radius: 0 8px 0 0;
}

.server-row {
    background: white;
    border-bottom: 1px solid #f1f3f4;
    transition: all 0.2s ease;
}

.server-row:hover {
    background: #f8f9ff;
    transform: scale(1.01);
}

.modern-table td {
    padding: 15px 12px;
    vertical-align: middle;
    border: none;
}

.server-info .server-name {
    font-weight: 600;
    color: #2c3e50;
    font-size: 0.95rem;
}

.server-info .server-description {
    color: #7f8c8d;
    font-size: 0.8rem;
    margin-top: 2px;
}

.network-info .ip-address {
    color: #495057;
    font-family: 'Monaco', 'Consolas', monospace;
    font-size: 0.85rem;
}

/* Status Badges */
.status-badge {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.status-online {
    background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
    color: #155724;
    border: 1px solid #c3e6cb;
}

.status-offline {
    background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
    color: #721c24;
    border: 1px solid #f5c6cb;
}

/* Barras de Progresso Modernas */
.metric-container {
    width: 100%;
}

.modern-progress {
    background: #f1f3f4;
    border-radius: 10px;
    height: 20px;
    position: relative;
    overflow: hidden;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

.progress-fill {
    height: 100%;
    border-radius: 10px;
    transition: width 0.6s ease;
    position: relative;
}

.progress-fill.success {
    background: linear-gradient(90deg, #4caf50 0%, #81c784 100%);
}

.progress-fill.warning {
    background: linear-gradient(90deg, #ff9800 0%, #ffb74d 100%);
}

.progress-fill.danger {
    background: linear-gradient(90deg, #f44336 0%, #e57373 100%);
}

.progress-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 0.75rem;
    font-weight: 600;
    color: rgb(83, 83, 83);
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.no-data {
    color: #adb5bd;
    font-style: italic;
    font-size: 0.85rem;
}

/* Alert Badges */
.alert-badge {
    padding: 4px 10px;
    border-radius: 15px;
    font-size: 0.75rem;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 3px;
}

.alert-success {
    background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
    color: #155724;
}

.alert-warning {
    background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
    color: #856404;
}

/* Botões de Ação */
.action-buttons {
    display: flex;
    gap: 8px;
    align-items: center;
}

.action-btn {
    background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
    border: none;
    border-radius: 8px;
    color: white;
    padding: 6px 12px;
    font-size: 0.8rem;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    transition: all 0.3s ease;
    cursor: pointer;
}

.action-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(23, 162, 184, 0.3);
    color: white;
    text-decoration: none;
}

.delete-btn {
    background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
}

.delete-btn:hover {
    box-shadow: 0 5px 15px rgba(220, 53, 69, 0.3);
}

/* Painel de Alertas */
.alerts-card {
    background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
}

/* Lista de Atividades */
.activity-list {
    max-height: 400px;
    overflow-y: auto;
}

.activity-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #f1f3f4;
    transition: all 0.2s ease;
}

.activity-item:hover {
    background: #f8f9ff;
    margin: 0 -15px;
    padding: 15px;
    border-radius: 8px;
}

.activity-item:last-child {
    border-bottom: none;
}

.activity-server {
    font-weight: 600;
    color: #2c3e50;
    font-size: 0.9rem;
}

.activity-time {
    color: #7f8c8d;
    font-size: 0.8rem;
    margin-top: 3px;
}

/* Chart Cards */
.chart-card,
.activity-card {
    background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
}

/* Responsividade */
@media (max-width: 768px) {
    .server-monitoring-dashboard {
        padding: 15px;
    }

    .dashboard-title {
        font-size: 2rem;
    }

    .metric-card {
        height: 160px;
    }

    .metric-content {
        padding: 20px;
        height: 110px;
    }

    .metric-info h3 {
        font-size: 2rem;
    }

    .modern-table {
        font-size: 0.8rem;
    }

    .modern-table td {
        padding: 10px 8px;
    }

    .confirmation-modal {
        width: 95%;
        margin: 10px;
    }

    .modal-header {
        padding: 20px 20px 15px;
    }

    .modal-body {
        padding: 20px;
    }

    .modal-footer {
        padding: 15px 20px 20px;
        flex-direction: column;
        gap: 10px;
    }

    .btn-cancel,
    .btn-confirm-delete {
        width: 100%;
        justify-content: center;
    }

    .header-actions {
        flex-direction: column;
        gap: 8px;
        align-items: stretch;
    }

    .btn-refresh,
    .btn-clear-data {
        width: 100%;
        justify-content: center;
    }
}

/* Animações */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.metric-card,
.data-card {
    animation: fadeInUp 0.6s ease forwards;
}

/* Scrollbar personalizada */
.activity-list::-webkit-scrollbar {
    width: 6px;
}

.activity-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.activity-list::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.activity-list::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* Modal de Confirmação */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(5px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    animation: fadeIn 0.3s ease;
}

.confirmation-modal {
    background: white;
    border-radius: 15px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    max-width: 500px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    animation: slideUp 0.3s ease;
}

.modal-header {
    padding: 25px 30px 20px;
    border-bottom: 1px solid #dee2e6;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 15px 15px 0 0;
}

.modal-title {
    margin: 0;
    font-size: 1.3rem;
    font-weight: 600;
    color: #2c3e50;
    display: flex;
    align-items: center;
}

.modal-body {
    padding: 30px;
}

.warning-text {
    color: #dc3545;
    font-weight: 500;
    margin-bottom: 20px;
    line-height: 1.5;
}

.deletion-list {
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 20px;
    margin: 20px 0;
    list-style: none;
}

.deletion-list li {
    padding: 8px 0;
    color: #495057;
    font-weight: 500;
    display: flex;
    align-items: center;
}

.deletion-list li i {
    color: #dc3545;
    width: 20px;
}

.confirmation-input {
    margin-top: 25px;
}

.confirmation-input label {
    display: block;
    margin-bottom: 10px;
    font-weight: 600;
    color: #2c3e50;
}

.confirmation-input .form-control {
    width: 100%;
    padding: 12px 15px;
    border: 2px solid #dee2e6;
    border-radius: 8px;
    font-size: 1rem;
    transition: all 0.3s ease;
}

.confirmation-input .form-control:focus {
    outline: none;
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.modal-footer {
    padding: 20px 30px 25px;
    border-top: 1px solid #dee2e6;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    background: #f8f9fa;
    border-radius: 0 0 15px 15px;
}

.btn-cancel {
    background: #6c757d;
    border: none;
    border-radius: 8px;
    color: white;
    padding: 10px 20px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-cancel:hover {
    background: #5a6268;
    transform: translateY(-1px);
}

.btn-confirm-delete {
    background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
    border: none;
    border-radius: 8px;
    color: white;
    padding: 10px 20px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-confirm-delete:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 5px 15px rgba(220, 53, 69, 0.3);
}

.btn-confirm-delete:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.text-danger {
    color: #dc3545 !important;
}

/* Animações do Modal */
@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px) scale(0.95);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* Modal de Confirmação */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(5px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    animation: fadeIn 0.3s ease;
}

.confirmation-modal {
    background: white;
    border-radius: 15px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    max-width: 500px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    animation: slideUp 0.3s ease;
}

.modal-header {
    padding: 25px 30px 20px;
    border-bottom: 1px solid #dee2e6;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 15px 15px 0 0;
}

.modal-title {
    margin: 0;
    font-size: 1.3rem;
    font-weight: 600;
    color: #2c3e50;
    display: flex;
    align-items: center;
}

.modal-body {
    padding: 30px;
}

.warning-text {
    color: #dc3545;
    font-weight: 500;
    margin-bottom: 20px;
    line-height: 1.5;
}

.deletion-list {
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 20px;
    margin: 20px 0;
    list-style: none;
}

.deletion-list li {
    padding: 8px 0;
    color: #495057;
    font-weight: 500;
    display: flex;
    align-items: center;
}

.deletion-list li i {
    color: #dc3545;
    width: 20px;
}

.confirmation-input {
    margin-top: 25px;
}

.confirmation-input label {
    display: block;
    margin-bottom: 10px;
    font-weight: 600;
    color: #2c3e50;
}

.confirmation-input .form-control {
    width: 100%;
    padding: 12px 15px;
    border: 2px solid #dee2e6;
    border-radius: 8px;
    font-size: 1rem;
    transition: all 0.3s ease;
}

.confirmation-input .form-control:focus {
    outline: none;
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.modal-footer {
    padding: 20px 30px 25px;
    border-top: 1px solid #dee2e6;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    background: #f8f9fa;
    border-radius: 0 0 15px 15px;
}

.btn-cancel {
    background: #6c757d;
    border: none;
    border-radius: 8px;
    color: white;
    padding: 10px 20px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-cancel:hover {
    background: #5a6268;
    transform: translateY(-1px);
}

.btn-confirm-delete {
    background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
    border: none;
    border-radius: 8px;
    color: white;
    padding: 10px 20px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-confirm-delete:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 5px 15px rgba(220, 53, 69, 0.3);
}

.btn-confirm-delete:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.text-danger {
    color: #dc3545 !important;
}

/* Animações do Modal */
@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px) scale(0.95);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* Estilos para Pesquisa de Aplicações */
.search-filters {
    background: #f8f9fa;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 20px;
}

.search-filters .form-control {
    border: 2px solid #e9ecef;
    border-radius: 8px;
    transition: all 0.3s ease;
}

.search-filters .form-control:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

.application-row {
    transition: all 0.2s ease;
}

.application-row:hover {
    background: #f8f9ff;
    transform: scale(1.01);
}

.app-info .app-name {
    font-weight: 600;
    color: #2c3e50;
    font-size: 0.9rem;
}

.app-info .app-size {
    color: #7f8c8d;
    font-size: 0.75rem;
    margin-top: 2px;
}

.type-badge {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 500;
    display: inline-block;
}

.type-laravel {
    background: linear-gradient(135deg, #ff2d20 0%, #e74c3c 100%);
    color: white;
}

.type-vue {
    background: linear-gradient(135deg, #41b883 0%, #35495e 100%);
    color: white;
}

.type-react {
    background: linear-gradient(135deg, #61dafb 0%, #282c34 100%);
    color: white;
}

.type-angular {
    background: linear-gradient(135deg, #dd0031 0%, #c3002f 100%);
    color: white;
}

.type-node {
    background: linear-gradient(135deg, #339933 0%, #2d5a2d 100%);
    color: white;
}

.type-python {
    background: linear-gradient(135deg, #3776ab 0%, #ffde57 100%);
    color: #333;
}

.type-java {
    background: linear-gradient(135deg, #007396 0%, #ed8b00 100%);
    color: white;
}

.type-php {
    background: linear-gradient(135deg, #777bb4 0%, #4f5b93 100%);
    color: white;
}

.type-default {
    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
    color: white;
}

.server-info .server-name {
    font-weight: 600;
    color: #2c3e50;
    font-size: 0.85rem;
}

.server-info .server-ip {
    color: #7f8c8d;
    font-size: 0.75rem;
    font-family: 'Monaco', 'Consolas', monospace;
}

.path-info code {
    background: #f8f9fa;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.8rem;
    color: #495057;
    font-family: 'Monaco', 'Consolas', monospace;
}

.env-badge {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 500;
}

.env-production {
    background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
    color: #155724;
}

.env-development {
    background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
    color: #856404;
}

.debug-badge {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 500;
}

.debug-enabled {
    background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
    color: #721c24;
}

.debug-disabled {
    background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
    color: #155724;
}

.status-warning {
    background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
    color: #856404;
}

.pagination-container {
    margin-top: 20px;
}

.pagination .page-link {
    border: none;
    color: #667eea;
    background: white;
    margin: 0 2px;
    border-radius: 6px;
    transition: all 0.3s ease;
}

.pagination .page-link:hover {
    background: #667eea;
    color: white;
    transform: translateY(-1px);
}

.pagination .page-item.active .page-link {
    background: #667eea;
    color: white;
}

.pagination .page-item.disabled .page-link {
    color: #6c757d;
    background: #f8f9fa;
    cursor: not-allowed;
}

.pagination-info {
    color: #6c757d;
    font-size: 0.85rem;
}

.no-results,
.initial-state {
    color: #6c757d;
}

.no-results i,
.initial-state i {
    opacity: 0.5;
}
</style>